module.exports = __webpack_public_path__ + "ec71e2eac60c48ef3103fbea2c0769.png";